import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PlatformToolGmtCountryAnalysisContentHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any>;
  commandEmitter: EventEmitter<any>;

  constructor(private router: Router) {
    this.invalidateSubject = new InvalidateSubject();
    this.commandEmitter = new EventEmitter<any>();
  }

  destroy(): void {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      this.commandEmitter.emit(command);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }

}
